import { render } from "./TermsofusepageCom.vue?vue&type=template&id=e454ecd8&scoped=true"
import script from "./TermsofusepageCom.vue?vue&type=script&lang=js"
export * from "./TermsofusepageCom.vue?vue&type=script&lang=js"

import "./TermsofusepageCom.vue?vue&type=style&index=0&id=e454ecd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e454ecd8"]])

export default __exports__